module.exports = __webpack_public_path__ + "static/media/stamp.40f13def.svg";